import React from 'react';
import { HubspotCROGuide } from './pages/HubspotCROGuide';
export function App() {
  return <HubspotCROGuide data-id="element-0" />;
}